import { twMerge } from '@utils/tailwind';
import { Button } from 'antd';
import React from 'react';
import type { IconType } from 'react-icons';

type Props = {
  icon: IconType
  isActive?: boolean
  onClick?: () => void
}

export function PortableTextInputToolbarButton({ icon: Icon, isActive, onClick }: Props) {
  return (
    <Button
      htmlType="button"
      type="default"
      className={twMerge(
        'm-1',
        isActive && 'bg-gray-300',
      )}
      onClick={onClick}
    >
      <Icon className="block" />
    </Button>
  )
}